import { Tabs, Radio } from 'antd';

import React, { useState, useEffect } from 'react'

const { TabPane } = Tabs;

export default (props) => {
  const stationIds = JSON.parse(sessionStorage.getItem('userInfo')).stationIds
  useEffect(()=>{
    
  },[])
  const [mode, setMode] = useState()
  const handleModeChange = (e) => {
    if(e=='-1'){
      props.getStationName(null)
    }else{
      let stationName = ''
      props.station.forEach((item) => {
          if(item.id==e){
             stationName = item.name
          }
      });
      props.getStationName(stationName)
    }
  };   

  return (
    <div>
      <Tabs  tabPosition={mode} onChange={handleModeChange} style={{ height: 220 }}>
         <TabPane tab={"全部"} key={-1} > </TabPane> 
        
        { 

            props.station && props.station.map(i => (
              <TabPane  tab={`${i.name}`} key={`${i.id}`} disabled={i === 28}>
              </TabPane>
          )) 
        }
      </Tabs>
    </div>
  );
}

